import { FORMAS_DE_CONTACTO } from "features/Contactos/constants"

export const mapContactosToPostContactos = (data = []) =>
  data.map((item) => {
    const telefonos = []
    const emails = []

    // @ts-expect-error TS(2339): Property 'email' does not exist on type 'never'.
    if (item?.email) {
      emails.push({
        nombre: "email",
        // @ts-expect-error TS(2339): Property 'email' does not exist on type 'never'.
        contacto: item?.email,
        tipoFormaContacto: FORMAS_DE_CONTACTO.EMAIL,
      })
    }

    // @ts-expect-error TS(2339): Property 'telefono' does not exist on type 'never'...
    if (item?.telefono) {
      telefonos.push({
        nombre: "telefono",
        // @ts-expect-error TS(2339): Property 'telefono' does not exist on type 'never'...
        contacto: item?.telefono,
        tipoFormaContacto: FORMAS_DE_CONTACTO.TELEFONO,
      })
    }

    return {
      // @ts-expect-error TS(2698): Spread types may only be created from object types...
      ...item,
      telefonos,
      emails,
    }
  })

export const mapContactosToPostContactosUpdated = (data = []) => {
  const arrayFiltered = data.map((item) => {
    const telefonos = []
    const emails = []

    // @ts-expect-error TS(2339): Property 'email' does not exist on type 'never'.
    if (item?.email) {
      emails.push({
        nombre: "email",
        // @ts-expect-error TS(2339): Property 'email' does not exist on type 'never'.
        contacto: item?.email,
        tipoFormaContacto: FORMAS_DE_CONTACTO.EMAIL,
      })
    }

    // @ts-expect-error TS(2339): Property 'telefono' does not exist on type 'never'...
    if (item?.telefono) {
      telefonos.push({
        nombre: "telefono",
        // @ts-expect-error TS(2339): Property 'telefono' does not exist on type 'never'...
        contacto: item?.telefono,
        tipoFormaContacto: FORMAS_DE_CONTACTO.TELEFONO,
      })
    }

    return {
      // @ts-expect-error TS(2698): Spread types may only be created from object types...
      ...item,
      telefonos,
      emails,
    }
  })
  return arrayFiltered
}

export const readCamposPersonalizados = (camposPersonalizados = []) => {
  return camposPersonalizados.map(({ clave, valor }) => ({ [clave]: valor }))
}
